















































































import { mixins } from 'vue-class-component'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import SearchPolicy from '@/mixins/search-queries/search-policy'
import { billingTypeValues, payerTypeValues } from '@/modules/Policy/helpers/policy'
import dollarFilter from '@/utils/dollarFilter'
import { IQuotePremiumInput } from '@/modules/Quote/interfaces/quote-form'
import PremiumCommissionSelector from '@/modules/Quote/components/PremiumCommissionSelector.vue'
import { CarrierProductCommission } from '@/modules/CarrierProduct/interfaces/carrier-product-commission'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppDatePicker,
    PremiumCommissionSelector
  }
})
export default class QuoteFormPremium extends mixins(SearchPolicy) {
  @Prop({ type: Object as () => IQuotePremiumInput }) value!: IQuotePremiumInput
  @Prop({ type: Array }) commissions!: CarrierProductCommission[]

  billingTypeOptions = billingTypeValues
  payerTypeOptions = payerTypeValues

  showCommission = false

  get totalTermAmount () {
    const {
      premium, agencyFee, carrierPolicyFee, inspectionFee,
      stampingFee, taxesFee, brokerFee
    } = this.value
    const total = (+premium) +
      (+agencyFee) +
      (+carrierPolicyFee) +
      (+inspectionFee) +
      (+stampingFee) +
      (+taxesFee) +
      (+brokerFee)

    return isNaN(total) ? '0.00' : total.toFixed(2)
  }

  get totalProjectedCommission () {
    const { commission, premium } = this.value

    const total = (+premium) * (+commission) / 100

    return isNaN(total) ? '0.00' : total.toFixed(2)
  }

  dollarFilter = dollarFilter

  @Watch('value.effectiveDate')
  onQuoteExffectiveDateChanged (val: string) {
    const { term } = this.value
    if (term) {
      this.value.expirationDate = this.$moment.unix(Number(val)).add(term, 'M').unix()
    }
  }

  @Watch('value.term')
  onQuoteTermDateChanged (val: string) {
    const { effectiveDate } = this.value
    if (effectiveDate) {
      this.value.expirationDate = this.$moment.unix(Number(effectiveDate)).add(val, 'M').unix()
    }
  }

  handleCommissionSelect (index: number) {
    const { commissions } = this
    this.value.commission = commissions[index] ? commissions[index].commission : ''
    this.showCommission = false
  }

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
